import React from 'react';
import styled from 'styled-components';
import Button from '../../../../../BaseComponentWrappers/MotifButton';
import { labels } from '../../../../../../../util/utils';
import { IconoirPlusCircle } from '@ey-xd/motif-icon';

export default function ControlAttributesButton(props) {
	const { handleOnClick } = props;

	return (
		<StyledControlAttributesButton className="ControlAttributesButton">
			<Button
				variant="text-alt"
				type="button"
				showLabel
				isEllipsed
				buttonLabel={labels.createNewControlAttribute}
				noOfLines={1}
				showIcon
				iconFunction={IconoirPlusCircle}
				onClick={handleOnClick}
			/>
		</StyledControlAttributesButton>
	);
}

const StyledControlAttributesButton = styled.section`
	display: block;
`;
